import { Search, X } from "lucide-react";

// BLOQUE 50 PARTE A — Buscar + Estado + Urgencia reutilizable en todas las pestañas
// de Compras (además del filtro Cliente->Obra->Presupuesto ya existente, Bloque 27).
// `statusOptions` es específico de cada pestaña: [{ value, label }], el primero
// siempre representa "sin filtro" (value="todos").
export function BusquedaEstadoUrgenciaFilters({
  search, setSearch, searchPlaceholder = "Buscar...",
  filterStatus, setFilterStatus, statusOptions = [],
  filterUrgency, setFilterUrgency,
  testIdPrefix = "filtro",
}) {
  return (
    <>
      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          placeholder={searchPlaceholder}
          value={search}
          onChange={e => setSearch(e.target.value)}
          className="pl-9 pr-3 py-2 border border-gray-200 rounded-xl text-xs bg-white focus:ring-2 focus:ring-[#2E6DA4]/20 focus:border-[#2E6DA4] w-48"
          data-testid={`${testIdPrefix}-search`}
        />
      </div>
      {statusOptions.length > 0 && (
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          className="border border-gray-200 rounded-xl px-3 py-2 text-xs bg-white" data-testid={`${testIdPrefix}-status-filter`}>
          {statusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </select>
      )}
      <select value={filterUrgency} onChange={e => setFilterUrgency(e.target.value)}
        className="border border-gray-200 rounded-xl px-3 py-2 text-xs bg-white" data-testid={`${testIdPrefix}-urgency-filter`}>
        <option value="">Todas las urgencias</option>
        <option value="critica">Crítico</option>
        <option value="alta">Alta</option>
        <option value="normal">Normal</option>
      </select>
    </>
  );
}

// BLOQUE 50 PARTE B — orden único: pendientes (según el criterio propio de cada
// pestaña, vía `isPendingFn`) siempre arriba, terminados abajo; dentro de cada
// grupo, el más nuevo primero (created_at descendente). Solo presentación — no
// muta el array recibido ni cambia datos/cálculos.
export function sortPendingFirst(list, isPendingFn, dateField = "created_at") {
  return [...(list || [])].sort((a, b) => {
    const pa = isPendingFn(a) ? 0 : 1;
    const pb = isPendingFn(b) ? 0 : 1;
    if (pa !== pb) return pa - pb;
    const da = new Date(a?.[dateField] || 0).getTime();
    const db = new Date(b?.[dateField] || 0).getTime();
    return db - da;
  });
}
